export const replaceCountry = (text = '') => text.replace(', United States', '').replace(', USA', '');
